var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "busiest-period" } }, [
    _c("div", { staticClass: "busiest-period-container" }, [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("FilterTool", {
            attrs: { isGraphShowing: true, "keep-state-on-query-params": true },
            model: {
              value: _vm.filters,
              callback: function ($$v) {
                _vm.filters = $$v
              },
              expression: "filters",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            {
              staticClass:
                "h-50 d-flex flex-column justify-content-center align-items-center text-align-center",
            },
            [
              _c("a-spin"),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))]),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "busiest-period-container" },
            [
              _vm.chartData.length
                ? _c("ChartsGraphic", {
                    key: "" + _vm.renderKey,
                    attrs: {
                      "data-prop": _vm.chartData,
                      "sub-title": "busiestPeriod",
                    },
                  })
                : _c(
                    "div",
                    { staticClass: "d-flex justify-content-center mt-5" },
                    [
                      _c("ChartNotFound", {
                        attrs: { title: _vm.$t("message.dataNotFound") },
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }